import React from 'react'

const phaseContainerContext = React.createContext({
  setIsUpdatingLocalPhase: () => {},
})

export default phaseContainerContext
